import { create } from "zustand";

import { Campaign } from "../models/Campaign";

type State = Campaign;

type Actions = {
  setCampaign: (state: Campaign) => void;
};

const campaignStore = create<State & Actions>(set => ({
  campaignDetails: [],
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
  },

  setCampaign: newState =>
    set(() => ({
      ...newState,
    })),
}));

export const useCampaignStore = () => {
  return campaignStore(store => ({
    campaignDetails: store.campaignDetails,
    pagination: store.pagination,
  }));
};

export const useSetCampaignStore = () => {
  return campaignStore(store => store.setCampaign);
};
